import { render } from "./ExpenseAction.vue?vue&type=template&id=60e5d624"
import script from "./ExpenseAction.vue?vue&type=script&lang=js"
export * from "./ExpenseAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__